export interface EmailAddressWithAlias {
  address: string;
  alias?: string;
}

export enum EmailTemplateType {
  UserInvite = 'UserInvite',
  ForgotPassword = 'ForgotPassword',
  LockRequest = 'LockRequest',
}

export interface EmailTemplateDto {
  emailTemplateType: EmailTemplateType;
  toAddresses: EmailAddressWithAlias[];
  ccAddresses: EmailAddressWithAlias[];
  bccAddresses: EmailAddressWithAlias[];
  replyToAddress?: EmailAddressWithAlias;
  fromAddress?: EmailAddressWithAlias;
  subject: string;
  htmlTemplate: string;
  reactSourceCode: string;
}

export interface EmailTemplateViewModel extends EmailTemplateDto {
  emailTemplateId: number;
  tenantId: string;
  createdDate: string;
  createdBy: string;
  updatedDate?: string | null;
  updatedBy?: string | null;
}
